import React from 'react'
import './Services.css'
import AnimatedShapes from "../AnimatedShapes";


const Services = () => {
    return (
        <>
            <div className="services">
            <h2 className="p-3 text-center">Technology</h2>
            <br />
            <div className="container">
                <div className="row">
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12 mx-auto mb-3">
                        <div className="card">
                            <h3>Front-end Development</h3>
                            <p>Html5 , Css3 , Javascript , Bootstrap, React.Js</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12 mx-auto mb-3">
                        <div className="card">
                             <h3>Back-end Development</h3>
                            <p>Php , Node.Js , Express.Js, Laravel 8 </p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-4 col-sm-6 col-12 mx-auto mb-3">
                        <div className="card">
                             <h3>Database </h3>
                            <p>Mysql , MongoDB</p>
                        </div>
                    </div>
                   
                </div>
            </div>
            <AnimatedShapes/>
            </div>
           


           
        </>
    )
}

export default Services
